import { Modal } from '@/components/base/Modal'
import { Trans } from '@/components'
import { ExpirationBehavior } from '@/pages/create-instance/components/ExpirationBehavior'

export function ExpirationBehaviorModal({
  open,
  onClose,
  onChange,
  value,
}: {
  open: boolean
  onClose: () => void
  onChange: (value: boolean) => void
  value: boolean
}) {
  return (
    <Modal open={open} onClose={onClose} className="w-[640px]">
      <Modal.Header>
        <Trans i18nKey="instance.detail.billing.expirationBehavior">Expiration Behavior</Trans>
      </Modal.Header>
      <Modal.Body>
        <ExpirationBehavior value={value} onChange={onChange} className="w-full" />
      </Modal.Body>
    </Modal>
  )
}
